import { TimeRange, toDateTimeStr } from '@mi-front/core';
import { Timer } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { theme as uiTheme } from '@ui/styles';
import classNames from 'classnames';
import { DurationForRange } from '../../../../components/date-time/DateTime';
import { StreamElContainerProps } from '../../../../components/stream/stream-el/StreamEl';

const StyledDuration = styled('div')(({ theme }) => ({
  fontSize: '0.75rem',
  lineHeight: '1.5rem',
  color: theme.palette.common.white,
  display: 'flex',
  marginLeft: theme.spacing(0.5),
}));

const StyledIcon = styled('div')(({ theme }) => ({
  padding: '0 0.5rem',
  background: theme.palette.primary.main, // $color-Aqua
  borderTopLeftRadius: '2px',
  borderBottomLeftRadius: '2px',
  width: '1.5rem',
}));

const StyledValue = styled('div')({
  padding: '0 0.5rem',
  borderTopRightRadius: '2px',
  borderBottomRightRadius: '2px',
  width: '6.5rem',
  background: '#92e1fe', // $color-AquaLight
  // Background is always light aqua; use fixed dark text, not palette.text.primary (light in dark mode).
  color: uiTheme.grayNew950,
});

interface Props extends StreamElContainerProps {
  readonly range: TimeRange<number>;
}

export function DurationLabel({ elProps = {}, ...p }: Props) {
  const { from, to } = p.range;

  return (
    <StyledDuration className={classNames('label-duration')}>
      <StyledIcon>
        <Timer />
      </StyledIcon>
      <StyledValue>
        <DurationForRange from={toDateTimeStr(from)} to={toDateTimeStr(to)} />
      </StyledValue>
    </StyledDuration>
  );
}
